import api from '@/api/api.js'

export default {
    /**
     * Recupère les soins et hospitalisation en cours
     * @returns 
     */
    getSoinsEnCours() {
        const promise = api.clinique().get('/facturation/soins')
        return promise.then(response => response.data)
    },
    getSoinsEnCoursByDate(date) {
        const promise = api.clinique().get('/facturation/soins/' + date)
        return promise.then(response => response.data)
    },

    getSoinsEnCoursByConsultation(consultation_id, soins_state) {
        const promise = api.clinique().get(`/facturation/soins/${consultation_id}/${soins_state}`)
        return promise.then(response => response.data)
    },

    // getSoinsEnCoursByDate(consultation_id, date) {
    //     const promise = api.clinique().get(`/conduite_a_tenirs/${consultation_id}/${date}`)
    //     return promise.then(response => response.data)
    // },

    sendStateSoinsValider(data) {
        const promise = api.clinique().put(`send/conduite_a_tenirs`, data)
        return promise.then(response => response.data)
    },

    sendStateSoinsValiderTraite(data) {
        const promise = api.clinique().put(`send/conduite_a_tenirs/traite`, data)
        return promise.then(response => response.data)
    },

    saveSoinsSansConsultation(data) {
        const promise = api.clinique().post(`/soins/sans_consultation`, data)
        return promise.then(response => response.data)
    },

    setFactureActeSoins(data) {
        const promise = api.clinique().post(`/soins/sans_consultation/facture`, data)
        return promise.then(response => response.data)
    },

    getSoinsSansConsultation() {
        const promise = api.clinique().get(`/soins/sans_consultation`)
        return promise.then(response => response.data)
    },

    /**
     * Recupère l'ID des jours programmé pour les conduites à tenir
     * @returns 
     */
    getCatJourID(idConsultation, status) {

        if (status) {
            const promise = api.clinique().get(`/cat/${idConsultation}/jours/${status}`)
            return promise.then(response => response.data)
        } else {
            const promise = api.clinique().get(`/cat/${idConsultation}/jours`)
            return promise.then(response => response.data)
        }

    },

    /**
     * Désactive / active un jour programmé pour les conduites à tenir
     * @param {*} jourID            /   ID du jour à désactiver
     * @param {*} etat              // 0 si activé | 1 si désactivé
     * @returns 
     */
    deactiveJourCat(jour_id, etat) {
        const promise = api.clinique().put(`/cats/${jour_id}/${etat}`)
        return promise.then(response => response.data)
    },

    getTarifSoins() {
        const promise = api.clinique().get('/prestations/soins')
        return promise.then(response => response.data)
    },

    getListeChirurgies(){
        const promise = api.clinique().get('/config/chirurgies')
        return promise.then(response => response.data)
    },
}